import { UiSchema } from 'prove-common/rjsf'

export const filterTasksUiSchema: UiSchema = {
  planIds: {
    'ui:hideOptionalLabel': true
  },
  subPlanIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  productIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  matrixIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  sampntTypeIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  purposeIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  subPurposeIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  substanceIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  }
}
